import React from 'react';
import { useReconnectStore } from '../../store/reconnectSlice';
import { multiplayerService } from '../../services/MultiplayerService';

const overlayStyle: React.CSSProperties = {
  position: 'fixed',
  inset: 0,
  zIndex: 9500,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: 'rgba(8,8,12,0.96)',
  color: '#fff',
  font: '18px sans-serif',
};

const quitButtonStyle: React.CSSProperties = {
  marginTop: 16,
  padding: '8px 20px',
  cursor: 'pointer',
};

const columnStyle: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
};

export const ReconnectOverlay = () => {
  const reconnecting = useReconnectStore((s) => s.reconnecting);
  const waiting = useReconnectStore((s) => s.waiting);
  if (!reconnecting) {
    return null;
  }
  return (
    <div style={overlayStyle}>
      <div style={columnStyle}>
        <div>{waiting ? 'En attente de l’hôte…' : 'Reconnexion…'}</div>
        {waiting ? (
          <button
            type="button"
            style={quitButtonStyle}
            onClick={() => multiplayerService.quitWaiting()}
          >
            Quitter
          </button>
        ) : (
          <button
            type="button"
            style={quitButtonStyle}
            onClick={() => multiplayerService.cancelBootResume()}
          >
            Annuler
          </button>
        )}
      </div>
    </div>
  );
};
